import PropTypes from "prop-types"

import { cn } from "styles/utils"

const cleanDim = (value) => {
  if (!value) return null
  // If it's already a number, return it
  if (typeof value === "number") return value
  // If it's a string, parse it (parseFloat stops reading at the first non-number char)
  const number = parseFloat(value)
  return isNaN(number) ? null : number
}

const Image = ({
  alt,
  className,
  fallback,
  height,
  isPicture,
  lazyload,
  sizes,
  src,
  srcSet,
  style,
  width,
  ...props
}) => {
  const safeHeight = isPicture ? null : cleanDim(height)
  const safeWidth = isPicture ? null : cleanDim(width)
  const ratioStyle =
    safeHeight && safeWidth
      ? { aspectRatio: `${safeWidth} / ${safeHeight}` }
      : {}

  return (
    <img
      alt={alt || ""}
      className={cn(className, lazyload && "lazyload")}
      height={height}
      width={width}
      {...(lazyload
        ? {
            "data-src": src,
            "data-srcset": srcSet,
            src: fallback || "https://assets.jewlr.com/icons/jewlr.gif",
            ...(sizes ? { sizes } : { "data-sizes": "auto" }),
          }
        : {
            fetchPriority: "high",
            loading: "eager",
            sizes,
            src,
            srcSet,
          })}
      style={{
        ...ratioStyle,
        ...style,
      }}
      {...props}
    />
  )
}

Image.defaultProps = {
  lazyload: true,
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallback: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPicture: PropTypes.bool,
  lazyload: PropTypes.bool,
  sizes: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Image.displayName = "Image"

export default Image
